import { gate } from 'hub-http/gates';
export const PRE_APPROVED = 'Payments:Pay040PreApprovedEnrollment';
export const KYC_EMBEDDED_FALLBACK_EXPERIENCE = gate('Payments:StripeEmbeddedOnboardingFallback');
export const PRODUCT_BUILDER = gate('commerce:product:product-builder');
export const CPQ_QUOTES_GATE = gate('commerce:cpq:bse:CPQQuote');
export const SHARED_TASKS_COMPONENTS_MIGRATION = gate('TACQ:SharedTaskComponentsMigration');
export const QUOTES_SECTION_DEALS_KANBAN = gate('commerce:cpq:QuotesSectionDealsKanban');
export const CPQ_UPGRADES_GATE = gate('commerce:cpq:upgrades');
export const ACTIVE_CQT_PORTAL = gate('commerce:cpq:ActiveCQTQuotesPortals');
export const NEW_PORTAL_CPQ_EXPERIENCE = gate('commerce:cpq:newPortalCPQExperience');
export const COMMERCE_OVERVIEW_REVAMP = gate('commerce:overview:revamp');
export const PRODUCT_BUILDER_IFRAME_GATE = gate('commerce:products:productCreatorIFrame');